import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { _nullishCoalesce } from '@sentry/utils/esm/buildPolyfills';
import { getCurrentHub } from '@sentry/hub';
import { uuid4, timestampWithMs, dropUndefinedKeys, isBaggageMutable, isSentryBaggageEmpty, createBaggage, setBaggageValue, setBaggageImmutable } from '@sentry/utils';
/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */

var SpanRecorder = /*#__PURE__*/function () {
  function SpanRecorder() {
    var maxlen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;

    _classCallCheck(this, SpanRecorder);

    ;

    SpanRecorder.prototype.__init.call(this);

    this._maxlen = maxlen;
  }
  /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */


  _createClass(SpanRecorder, [{
    key: "__init",
    value: function __init() {
      this.spans = [];
    }
  }, {
    key: "add",
    value: function add(span) {
      if (this.spans.length > this._maxlen) {
        span.spanRecorder = undefined;
      } else {
        this.spans.push(span);
      }
    }
  }]);

  return SpanRecorder;
}();
/**
 * Span contains all data about a span
 */


var Span = /*#__PURE__*/function () {
  /**
   * List of spans that were finalized
   */

  /**
   * @inheritDoc
   */

  /**
   * You should never call the constructor manually, always use `Sentry.startTransaction()`
   * or call `startChild()` on an existing span.
   * @internal
   * @hideconstructor
   * @hidden
   */
  function Span(spanContext) {
    _classCallCheck(this, Span);

    ;

    Span.prototype.__init2.call(this);

    Span.prototype.__init3.call(this);

    Span.prototype.__init4.call(this);

    Span.prototype.__init5.call(this);

    Span.prototype.__init6.call(this);

    if (!spanContext) {
      return this;
    }

    if (spanContext.traceId) {
      this.traceId = spanContext.traceId;
    }

    if (spanContext.spanId) {
      this.spanId = spanContext.spanId;
    }

    if (spanContext.parentSpanId) {
      this.parentSpanId = spanContext.parentSpanId;
    } // We want to include booleans as well here


    if ('sampled' in spanContext) {
      this.sampled = spanContext.sampled;
    }

    if (spanContext.op) {
      this.op = spanContext.op;
    }

    if (spanContext.description) {
      this.description = spanContext.description;
    }

    if (spanContext.data) {
      this.data = spanContext.data;
    }

    if (spanContext.tags) {
      this.tags = spanContext.tags;
    }

    if (spanContext.status) {
      this.status = spanContext.status;
    }

    if (spanContext.startTimestamp) {
      this.startTimestamp = spanContext.startTimestamp;
    }

    if (spanContext.endTimestamp) {
      this.endTimestamp = spanContext.endTimestamp;
    }
  }
  /**
   * @inheritDoc
   */


  _createClass(Span, [{
    key: "__init2",
    value:
    /**
     * @inheritDoc
     */
    function __init2() {
      this.traceId = uuid4();
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "__init3",
    value: function __init3() {
      this.spanId = uuid4().substring(16);
    }
    /**
     * @inheritDoc
     */

    /**
     * Internal keeper of the status
     */

    /**
     * @inheritDoc
     */

    /**
     * Timestamp in seconds when the span was created.
     */

  }, {
    key: "__init4",
    value: function __init4() {
      this.startTimestamp = timestampWithMs();
    }
    /**
     * Timestamp in seconds when the span ended.
     */

    /**
     * @inheritDoc
     */

    /**
     * @inheritDoc
     */

    /**
     * @inheritDoc
     */

  }, {
    key: "__init5",
    value: function __init5() {
      this.tags = {};
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "__init6",
    value: function __init6() {
      this.data = {};
    }
  }, {
    key: "startChild",
    value: function startChild(spanContext) {
      var childSpan = new Span(_objectSpread(_objectSpread({}, spanContext), {}, {
        parentSpanId: this.spanId,
        sampled: this.sampled,
        traceId: this.traceId
      }));
      childSpan.spanRecorder = this.spanRecorder;

      if (childSpan.spanRecorder) {
        childSpan.spanRecorder.add(childSpan);
      }

      childSpan.transaction = this.transaction;
      return childSpan;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "setTag",
    value: function setTag(key, value) {
      this.tags = _objectSpread(_objectSpread({}, this.tags), {}, _defineProperty({}, key, value));
      return this;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "setData",
    value: function setData(key, value) {
      this.data = _objectSpread(_objectSpread({}, this.data), {}, _defineProperty({}, key, value));
      return this;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "setStatus",
    value: function setStatus(value) {
      this.status = value;
      return this;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "setHttpStatus",
    value: function setHttpStatus(httpStatus) {
      this.setTag('http.status_code', String(httpStatus));
      var spanStatus = spanStatusfromHttpCode(httpStatus);

      if (spanStatus !== 'unknown_error') {
        this.setStatus(spanStatus);
      }

      return this;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "isSuccess",
    value: function isSuccess() {
      return this.status === 'ok';
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "finish",
    value: function finish(endTimestamp) {
      this.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : timestampWithMs();
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toTraceparent",
    value: function toTraceparent() {
      var sampledString = '';

      if (this.sampled !== undefined) {
        sampledString = this.sampled ? '-1' : '-0';
      }

      return "".concat(this.traceId, "-").concat(this.spanId).concat(sampledString);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toContext",
    value: function toContext() {
      return dropUndefinedKeys({
        data: this.data,
        description: this.description,
        endTimestamp: this.endTimestamp,
        op: this.op,
        parentSpanId: this.parentSpanId,
        sampled: this.sampled,
        spanId: this.spanId,
        startTimestamp: this.startTimestamp,
        status: this.status,
        tags: this.tags,
        traceId: this.traceId
      });
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "updateWithContext",
    value: function updateWithContext(spanContext) {
      var _this = this;

      this.data = _nullishCoalesce(spanContext.data, function () {
        return {};
      });
      this.description = spanContext.description;
      this.endTimestamp = spanContext.endTimestamp;
      this.op = spanContext.op;
      this.parentSpanId = spanContext.parentSpanId;
      this.sampled = spanContext.sampled;
      this.spanId = _nullishCoalesce(spanContext.spanId, function () {
        return _this.spanId;
      });
      this.startTimestamp = _nullishCoalesce(spanContext.startTimestamp, function () {
        return _this.startTimestamp;
      });
      this.status = spanContext.status;
      this.tags = _nullishCoalesce(spanContext.tags, function () {
        return {};
      });
      this.traceId = _nullishCoalesce(spanContext.traceId, function () {
        return _this.traceId;
      });
      return this;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "getTraceContext",
    value: function getTraceContext() {
      return dropUndefinedKeys({
        data: Object.keys(this.data).length > 0 ? this.data : undefined,
        description: this.description,
        op: this.op,
        parent_span_id: this.parentSpanId,
        span_id: this.spanId,
        status: this.status,
        tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
        trace_id: this.traceId
      });
    }
    /**
     * @inheritdoc
     */

  }, {
    key: "getBaggage",
    value: function getBaggage() {
      var existingBaggage = this.transaction && this.transaction.metadata.baggage; // Only add Sentry baggage items to baggage, if baggage does not exist yet or it is still
      // empty and mutable

      var finalBaggage = !existingBaggage || isBaggageMutable(existingBaggage) && isSentryBaggageEmpty(existingBaggage) ? this._getBaggageWithSentryValues(existingBaggage) : existingBaggage;
      return finalBaggage;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toJSON",
    value: function toJSON() {
      return dropUndefinedKeys({
        data: Object.keys(this.data).length > 0 ? this.data : undefined,
        description: this.description,
        op: this.op,
        parent_span_id: this.parentSpanId,
        span_id: this.spanId,
        start_timestamp: this.startTimestamp,
        status: this.status,
        tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
        timestamp: this.endTimestamp,
        trace_id: this.traceId
      });
    }
    /**
     * Collects and adds data to the passed baggage object.
     *
     * Note: This function does not explicitly check if the passed baggage object is allowed
     * to be modified. Implicitly, `setBaggageValue` will not make modification to the object
     * if it was already set immutable.
     *
     * After adding the data, the baggage object is set immutable to prevent further modifications.
     *
     * @param baggage
     *
     * @returns modified and immutable baggage object
     */

  }, {
    key: "_getBaggageWithSentryValues",
    value: function _getBaggageWithSentryValues() {
      var baggage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : createBaggage({});
      var hub = this.transaction && this.transaction._hub || getCurrentHub();
      var client = hub.getClient();

      var _ref = client && client.getOptions() || {},
          environment = _ref.environment,
          release = _ref.release;

      environment && setBaggageValue(baggage, 'environment', environment);
      release && setBaggageValue(baggage, 'release', release);
      setBaggageImmutable(baggage);
      return baggage;
    }
  }]);

  return Span;
}();
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */


function spanStatusfromHttpCode(httpStatus) {
  if (httpStatus < 400 && httpStatus >= 100) {
    return 'ok';
  }

  if (httpStatus >= 400 && httpStatus < 500) {
    switch (httpStatus) {
      case 401:
        return 'unauthenticated';

      case 403:
        return 'permission_denied';

      case 404:
        return 'not_found';

      case 409:
        return 'already_exists';

      case 413:
        return 'failed_precondition';

      case 429:
        return 'resource_exhausted';

      default:
        return 'invalid_argument';
    }
  }

  if (httpStatus >= 500 && httpStatus < 600) {
    switch (httpStatus) {
      case 501:
        return 'unimplemented';

      case 503:
        return 'unavailable';

      case 504:
        return 'deadline_exceeded';

      default:
        return 'internal_error';
    }
  }

  return 'unknown_error';
}

export { Span, SpanRecorder, spanStatusfromHttpCode };